import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'
import { getCurrentTimestamp } from "../utils/utils";

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/notifications';

// Newest first (the old "ascL" direction was a typo that returned the oldest notifications first).
export const listYourNotifications = (userId, page, size, sort) => axiosInstance.get(REST_API_BASE_URL + '/' + userId, { params: { page, size, sort: `${sort},desc` } });

export const deleteAllYourNotifications = (userId) => axiosInstance.delete(REST_API_BASE_URL + '/all/' + userId);

export const deleteYourNotification = (notificationId, userId) => axiosInstance.delete(REST_API_BASE_URL + '/' + notificationId + '/' + userId);

export const markOnTopNotification = (notificationId, markOnTop) => axiosInstance.put(REST_API_BASE_URL + '/markontop/' + notificationId, markOnTop);

export const createYourNotification = (notification) => axiosInstance.post(REST_API_BASE_URL, notification);

export const createUserNotifications = (userId) => axiosInstance.post(REST_API_BASE_URL + '/usernotifications/' + userId);

/** Fire-and-forget helper used after user actions (publish, favourite, apply...). */
export const notifyUser = (userId, { notificationName, notificationType }) => {
    if (!userId) return Promise.resolve(null);
    return createYourNotification({
        notificationName,
        notificationType,
        notificationData: getCurrentTimestamp(),
        userId: Number(userId),
        markOnTop: false,
        markOnTopData: null,
    }).catch((error) => {
        console.error(error);
        return null;
    });
};
